import { Typography } from 'antd';
import React from 'react';

const { Title } = Typography;

const EducationTitle = () => {
    return (
        <>
            <div style={{ backgroundColor: '#112240' }}>
                <div style={{ padding: '5rem 0', textAlign: 'center', }}>
                    <Title level={3} style={{ color: '#fff', }}>Educational Qualification </Title>
                   
                    <Title level={5} style={{ color: '#fff', textTransform: 'uppercase' }} >"There are no short cuts to any place worth going"</Title>
                </div>
            </div>
        </>
    );
};

export default EducationTitle;